import { useState } from 'react'
import { TodoForm } from './TodoForm'
import {v4 as uuidv4} from 'uuid';
import { Todo } from './Todo';
import { EditTodoForm } from './EditTodoForm';
uuidv4()

export const TodoWrapper = () => {
  const [todos,setTodos] = useState([])
  
  const addTodo = todo =>{
    setTodos([...todos,{id:uuidv4(),
        task:todo,
        completed:false,
        isEditing:false}])
    console.log(todos)
  }
  const toggleCompleted = (id) =>{
    setTodos(todos.map(todo=>(todo.id === id ?{
      ...todo,completed:!todo.completed}:todo)
    ))
  }

  const deleteTodo = (id) =>{
    setTodos(todos.filter(todo=>todo.id !== id))
  }
  
  const EditTodo = (id) =>{
    setTodos(todos.map(todo=>(todo.id === id ?{
      ...todo,isEditing:!todo.isEditing}:todo)
      ))
    }
  
    const editTask = (task,id) =>{
      setTodos(todos.map(todo=>(todo.id === id ?{
        ...todo,task,isEditing:!todo.isEditing}:todo)
        ))
    }

  return (
    <div className='todoWrapper'>
      <h1>Get think done!</h1>
      <TodoForm addTodo={addTodo}/>
      {todos.map((e,i)=>(
        e.isEditing?(<EditTodoForm editTodo={editTask} task={e}/>):
      (<Todo key={i}
       task={e}
       toggleCompleted={toggleCompleted}
       deleteTodo={deleteTodo}
       EditTodo={EditTodo}
       />)
      ))}
      
      </div>
  )
}
